import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface Product {
  product_id: number
  product_name: string
  sku_code: string
  category: string
  unit: string
  price_per_unit: number
  description: string
  status: string
}

export interface CategoryOption {
  category_name: string
  abbreviation: string
}

export interface UnitOption {
  unit_name: string
  abbreviation: string
}

export interface CatalogueOptions {
  categories: CategoryOption[]
  units: UnitOption[]
}

// ─── Product APIs ─────────────────────────────────────────────────────────────

export const getProducts = async (companyId: string): Promise<Product[] | undefined> => {
  return await axios
    .get(`${API_URL}/product-catalogue/list/${companyId}`)
    .then((response: AxiosResponse<Product[]>) => response.data)
    .then((response: Product[]) => response)
}

export const createProduct = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/product-catalogue/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const editProduct = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.put(`${API_URL}/product-catalogue/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteProduct = async (
  companyId: string,
  productId: number
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/product-catalogue/${companyId}/${productId}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

// ─── Options API (categories + units for form dropdowns) ─────────────────────

export const getCatalogueOptions = async (
  companyId: string
): Promise<CatalogueOptions | undefined> => {
  return await axios
    .get(`${API_URL}/product-catalogue/data/${companyId}`)
    .then((response: AxiosResponse<CatalogueOptions>) => response.data)
    .then((response: CatalogueOptions) => response)
}
